<template>
  <div :class="classes()">
    <div :class="`${el}__wrapper ${el}__infoWrapper`">
      <div :class="`${el}__infoImageBg`">
        <Illustration brushColor="primaryCoral" name="title-2" :brush="1" opacity="0.5" />
      </div>
      <div :class="`${el}__infoContent`">
        <Headline
          :size="$matchMedia.l ? 'l' : 's'"
          :heading="1"
          :staticClass="`${el}__infoHeadline`"
          centered
        >
          {{ $t(`auth.info.headline1`) }}
          <br />
          {{ $t(`auth.info.headline2`) }}
        </Headline>
        <div :class="`${el}__infoImage`">
          <Picture
            :img="$t('careLevelCalculator.landingPage.device.v1.image')"
            :width="665"
            :height="390"
            responsive
          />
        </div>
        <div :class="`${el}__copy`">
          <Copy centered>
            {{ $t('auth.copy') }}
          </Copy>
        </div>

        <div :class="`${el}__infoBottom`">
          <div :class="`${el}__infoList`">
            <UnorderedList
              :class="`${el}__infoUnorderedList`"
              :listItems="$t('auth.bullets')"
              iconName="check-line"
              bold
            />
          </div>

          <div :class="`${el}__tuev`">
            <TuevCertificate />
          </div>
        </div>
      </div>
    </div>
    <div :class="`${el}__wrapper ${el}__formWrapper`">
      <div :class="`${el}__form`">
        <slot name="formBox" />
      </div>
    </div>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Picture from '@/objects/Picture';
import Illustration from '@/objects/Illustration';
import UnorderedList from '@/objects/UnorderedList';
import TuevCertificate from '@/objects/TuevCertificate';

export default {
  name: 'AuthScreen',
  props: {},
  components: {
    UnorderedList,
    Picture,
    Illustration,
    Headline,
    Copy,
    TuevCertificate,
  },
  data() {
    return {
      el: 'c-authScreen',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
